export default {
    TABLE_SETTINGS: "Настройка таблицы",
    OK: "Применить",
    CANCEL: "Отменить",
    NO_AVAILABLE_OBJECT_TYPES: "Нет типов объектов, доступных для выбора",
    EXPORT: "Скачать",
    IMPORT_TO_CSV: "В формате .csv",
    IMPORT_TO_XLSX: "В формате .xlsx"
};
